import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdatePaymentTradesAdditionsRequestModel, UpdatePaymentTradesAdditionsResponseModel } from "@/features/accounts/payment/scraping/services/update-trades-additions-model";

export class UpdatePaymentTradesAdditionsApi {
  /**
   * MoneyLook明細メモ・無効明細更新API
   */
  public updatePaymentTradesAdditions = async (
    param: UpdatePaymentTradesAdditionsRequestModel
  ): Promise<UpdatePaymentTradesAdditionsResponseModel> => {
    const path = `/api/paymentaccounts/payments/tradesadditions`;
    const res = await ApiClient.instance.put<UpdatePaymentTradesAdditionsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
